import { getUtcDate } from './get-utc-date';

export function getUtcToday(): Date {
  const today = new Date();
  return getUtcDate(today);
}
